var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.experiments.length || _vm.isGenerating || _vm.errorMessage
    ? _c(
        "div",
        {
          staticClass: "section-wrapper",
          attrs: { id: "planner-search-results" },
        },
        [
          _c("div", { staticClass: "protocol-header" }, [
            _c("h4", [_vm._v("Generated Experiment Protocol")]),
            _c("div", { staticClass: "protocol-actions" }, [
              !_vm.isGenerating && _vm.experiments.length
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-sm btn-primary download-btn",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("download")
                        },
                      },
                    },
                    [_vm._v(" Download Experiment Plan ")]
                  )
                : _vm._e(),
              !_vm.isGenerating && _vm.experiments.length
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-sm btn-success citation-btn",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          _vm.showCitationPopup = true
                        },
                      },
                    },
                    [_vm._v(" Citation Information ")]
                  )
                : _vm._e(),
              !_vm.isGenerating && _vm.experiments.length
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-sm btn-alert",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          _vm.showDisclaimer = !_vm.showDisclaimer
                        },
                      },
                    },
                    [_vm._v(" Important Disclaimer ")]
                  )
                : _vm._e(),
            ]),
          ]),
          _vm.isGenerating
            ? _c("div", { staticClass: "loading-message" }, [
                _c("p", [
                  _vm._v(
                    "Creating your experiment protocol" +
                      _vm._s(_vm.elapsedTime ? ` (${_vm.elapsedTime})` : "") +
                      "..."
                  ),
                ]),
              ])
            : _vm._e(),
          _vm.errorMessage && !_vm.isGenerating
            ? _c(
                "div",
                { staticClass: "rd-protocol-error", attrs: { role: "alert" } },
                [_vm._v(" " + _vm._s(_vm.errorMessage) + " ")]
              )
            : _vm._e(),
          _vm.experiments.length
            ? _c("div", { staticClass: "experiment-results" }, [
                _vm.showDisclaimer
                  ? _c("div", { staticClass: "experiment-disclaimer" }, [
                      _vm._m(0),
                      _vm._m(1),
                    ])
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "experiment-plan" },
                  [
                    _vm._l(_vm.experiments, function (experiment, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "experiment-card" },
                        [
                          experiment.biological_assertion
                            ? _c("div", { staticClass: "experiment-section" }, [
                                _c("h6", { staticClass: "section-title" }, [
                                  _vm._v("Biological Assertion"),
                                ]),
                                _c(
                                  "div",
                                  { staticClass: "assertion-content" },
                                  [
                                    _c("div", { staticClass: "hypothesis" }, [
                                      _c("strong", [_vm._v("Hypothesis:")]),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            experiment.biological_assertion
                                              .hypothesis
                                          ) +
                                          " "
                                      ),
                                    ]),
                                    _c("div", { staticClass: "mechanism" }, [
                                      _c("strong", [_vm._v("Mechanism:")]),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            experiment.biological_assertion
                                              .mechanism
                                          ) +
                                          " "
                                      ),
                                    ]),
                                    _c("div", { staticClass: "phenotype" }, [
                                      _c("strong", [_vm._v("Phenotype:")]),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            experiment.biological_assertion
                                              .phenotype
                                          ) +
                                          " "
                                      ),
                                    ]),
                                    _c("div", { staticClass: "gene" }, [
                                      _c("strong", [_vm._v("Gene:")]),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            experiment.biological_assertion.gene
                                          ) +
                                          " "
                                      ),
                                    ]),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          experiment.suggested_experiment
                            ? _c("div", { staticClass: "experiment-section" }, [
                                _c("h6", { staticClass: "section-title" }, [
                                  _vm._v("Suggested Experiment"),
                                ]),
                                _c(
                                  "div",
                                  { staticClass: "experiment-description" },
                                  [
                                    Array.isArray(
                                      experiment.suggested_experiment.experiment
                                    )
                                      ? [
                                          _c(
                                            "ul",
                                            { staticClass: "setup-list" },
                                            _vm._l(
                                              experiment.suggested_experiment
                                                .experiment,
                                              function (item, idx) {
                                                return _c(
                                                  "li",
                                                  { key: "se-" + idx },
                                                  [
                                                    _vm._v(
                                                      " " + _vm._s(item) + " "
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          ),
                                        ]
                                      : [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                experiment.suggested_experiment
                                                  .experiment
                                              ) +
                                              " "
                                          ),
                                        ],
                                  ],
                                  2
                                ),
                              ])
                            : _vm._e(),
                          experiment.Why_validate
                            ? _c("div", { staticClass: "experiment-section" }, [
                                _c("h6", { staticClass: "section-title" }, [
                                  _vm._v("Why Validate"),
                                ]),
                                _c(
                                  "div",
                                  { staticClass: "validation-reasons" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "reason-item" },
                                      [
                                        _c("strong", [_vm._v("Feasibility:")]),
                                        Array.isArray(
                                          experiment.Why_validate.feasibility
                                        )
                                          ? [
                                              _c(
                                                "ul",
                                                { staticClass: "setup-list" },
                                                _vm._l(
                                                  experiment.Why_validate
                                                    .feasibility,
                                                  function (x, i) {
                                                    return _c(
                                                      "li",
                                                      { key: "wvf-" + i },
                                                      [
                                                        _vm._v(
                                                          " " + _vm._s(x) + " "
                                                        ),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                0
                                              ),
                                            ]
                                          : [
                                              _vm._v(
                                                _vm._s(
                                                  experiment.Why_validate
                                                    .feasibility
                                                )
                                              ),
                                            ],
                                      ],
                                      2
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "reason-item" },
                                      [
                                        _c("strong", [_vm._v("Impact:")]),
                                        Array.isArray(
                                          experiment.Why_validate.Impact
                                        )
                                          ? [
                                              _c(
                                                "ul",
                                                { staticClass: "setup-list" },
                                                _vm._l(
                                                  experiment.Why_validate
                                                    .Impact,
                                                  function (x, i) {
                                                    return _c(
                                                      "li",
                                                      { key: "wvi-" + i },
                                                      [
                                                        _vm._v(
                                                          " " + _vm._s(x) + " "
                                                        ),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                0
                                              ),
                                            ]
                                          : [
                                              _vm._v(
                                                _vm._s(
                                                  experiment.Why_validate.Impact
                                                )
                                              ),
                                            ],
                                      ],
                                      2
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "reason-item" },
                                      [
                                        _c("strong", [_vm._v("Novelty:")]),
                                        Array.isArray(
                                          experiment.Why_validate.Novelty
                                        )
                                          ? [
                                              _c(
                                                "ul",
                                                { staticClass: "setup-list" },
                                                _vm._l(
                                                  experiment.Why_validate
                                                    .Novelty,
                                                  function (x, i) {
                                                    return _c(
                                                      "li",
                                                      { key: "wvn-" + i },
                                                      [
                                                        _vm._v(
                                                          " " + _vm._s(x) + " "
                                                        ),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                0
                                              ),
                                            ]
                                          : [
                                              _vm._v(
                                                _vm._s(
                                                  experiment.Why_validate
                                                    .Novelty
                                                )
                                              ),
                                            ],
                                      ],
                                      2
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          experiment.protocol_sketch
                            ? _c("div", { staticClass: "experiment-section" }, [
                                _c("h6", { staticClass: "section-title" }, [
                                  _vm._v("Protocol Sketch"),
                                ]),
                                _c("div", { staticClass: "protocol-details" }, [
                                  _c("div", { staticClass: "protocol-item" }, [
                                    _c("strong", [_vm._v("Design:")]),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          experiment.protocol_sketch.design
                                        ) +
                                        " "
                                    ),
                                  ]),
                                  _c("div", { staticClass: "protocol-item" }, [
                                    _c("strong", [_vm._v("Perturbation:")]),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          experiment.protocol_sketch
                                            .perturbation
                                        ) +
                                        " "
                                    ),
                                  ]),
                                  _c(
                                    "div",
                                    { staticClass: "protocol-item" },
                                    [
                                      _c("strong", [_vm._v("Readouts:")]),
                                      Array.isArray(
                                        experiment.protocol_sketch.readouts
                                      )
                                        ? [
                                            _c(
                                              "ul",
                                              { staticClass: "setup-list" },
                                              _vm._l(
                                                experiment.protocol_sketch
                                                  .readouts,
                                                function (r, rIdx) {
                                                  return _c(
                                                    "li",
                                                    { key: "ro-" + rIdx },
                                                    [
                                                      _vm._v(
                                                        " " + _vm._s(r) + " "
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                          ]
                                        : [
                                            _vm._v(
                                              _vm._s(
                                                experiment.protocol_sketch
                                                  .readouts
                                              )
                                            ),
                                          ],
                                    ],
                                    2
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "protocol-item" },
                                    [
                                      _c("strong", [_vm._v("Controls:")]),
                                      Array.isArray(
                                        experiment.protocol_sketch.controls
                                      )
                                        ? [
                                            _c(
                                              "ul",
                                              { staticClass: "setup-list" },
                                              _vm._l(
                                                experiment.protocol_sketch
                                                  .controls,
                                                function (c, cIdx) {
                                                  return _c(
                                                    "li",
                                                    { key: "ct-" + cIdx },
                                                    [
                                                      _vm._v(
                                                        " " + _vm._s(c) + " "
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                          ]
                                        : [
                                            _vm._v(
                                              _vm._s(
                                                experiment.protocol_sketch
                                                  .controls
                                              )
                                            ),
                                          ],
                                    ],
                                    2
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "protocol-item" },
                                    [
                                      _c("strong", [_vm._v("Analysis:")]),
                                      Array.isArray(
                                        experiment.protocol_sketch.analysis
                                      )
                                        ? [
                                            _c(
                                              "ul",
                                              { staticClass: "setup-list" },
                                              _vm._l(
                                                experiment.protocol_sketch
                                                  .analysis,
                                                function (a, aIdx) {
                                                  return _c(
                                                    "li",
                                                    { key: "an-" + aIdx },
                                                    [
                                                      _vm._v(
                                                        " " + _vm._s(a) + " "
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                          ]
                                        : [
                                            _vm._v(
                                              _vm._s(
                                                experiment.protocol_sketch
                                                  .analysis
                                              )
                                            ),
                                          ],
                                    ],
                                    2
                                  ),
                                ]),
                              ])
                            : _vm._e(),
                          experiment.feasibility_details
                            ? _c("div", { staticClass: "experiment-section" }, [
                                _c("h6", { staticClass: "section-title" }, [
                                  _vm._v("Feasibility Details"),
                                ]),
                                _c(
                                  "div",
                                  { staticClass: "feasibility-content" },
                                  [
                                    experiment.feasibility_details
                                      .required_capabilities
                                      ? _c(
                                          "div",
                                          { staticClass: "feasibility-item" },
                                          [
                                            _c("strong", [
                                              _vm._v("Required Capabilities:"),
                                            ]),
                                            _c(
                                              "ul",
                                              { staticClass: "setup-list" },
                                              _vm._l(
                                                experiment.feasibility_details
                                                  .required_capabilities,
                                                function (capability) {
                                                  return _c(
                                                    "li",
                                                    { key: capability },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(capability) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _c(
                                      "div",
                                      { staticClass: "feasibility-item" },
                                      [
                                        _c("strong", [
                                          _vm._v("Expected Timeline:"),
                                        ]),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              experiment.feasibility_details
                                                .expected_timeline
                                            ) +
                                            " "
                                        ),
                                        _vm._m(2, true),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "feasibility-item" },
                                      [
                                        _c("strong", [
                                          _vm._v("Estimated Conditions:"),
                                        ]),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              experiment.feasibility_details
                                                .Estimated_conditions
                                            ) +
                                            " "
                                        ),
                                        _vm._m(3, true),
                                      ]
                                    ),
                                    experiment.feasibility_details
                                      .required_materials
                                      ? _c(
                                          "div",
                                          { staticClass: "feasibility-item" },
                                          [
                                            _c("strong", [
                                              _vm._v("Required Materials:"),
                                            ]),
                                            _c(
                                              "ul",
                                              { staticClass: "materials-list" },
                                              _vm._l(
                                                experiment.feasibility_details
                                                  .required_materials,
                                                function (material) {
                                                  return _c(
                                                    "li",
                                                    { key: material },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(material) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          experiment.design_critique
                            ? _c("div", { staticClass: "experiment-section" }, [
                                _c("h6", { staticClass: "section-title" }, [
                                  _vm._v("Design Critique"),
                                ]),
                                _c("div", { staticClass: "critique-content" }, [
                                  experiment.design_critique.strengths
                                    ? _c(
                                        "div",
                                        { staticClass: "critique-section" },
                                        [
                                          _c("strong", [_vm._v("Strengths:")]),
                                          _c(
                                            "ul",
                                            {
                                              staticClass:
                                                "critique-list strengths",
                                            },
                                            _vm._l(
                                              experiment.design_critique
                                                .strengths,
                                              function (strength) {
                                                return _c(
                                                  "li",
                                                  { key: strength },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(strength) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  experiment.design_critique.limitations
                                    ? _c(
                                        "div",
                                        { staticClass: "critique-section" },
                                        [
                                          _c("strong", [
                                            _vm._v("Limitations:"),
                                          ]),
                                          _c(
                                            "ul",
                                            {
                                              staticClass:
                                                "critique-list limitations",
                                            },
                                            _vm._l(
                                              experiment.design_critique
                                                .limitations,
                                              function (limitation) {
                                                return _c(
                                                  "li",
                                                  { key: limitation },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(limitation) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  experiment.design_critique
                                    .justification_for_deviation
                                    ? _c(
                                        "div",
                                        { staticClass: "critique-section" },
                                        [
                                          _c("strong", [
                                            _vm._v(
                                              "Justification for Deviation:"
                                            ),
                                          ]),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "justification-text",
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    experiment.design_critique
                                                      .justification_for_deviation
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  experiment.design_critique
                                    .alternative_approaches
                                    ? _c(
                                        "div",
                                        { staticClass: "critique-section" },
                                        [
                                          _c("strong", [
                                            _vm._v("Alternative Approaches:"),
                                          ]),
                                          _c(
                                            "div",
                                            { staticClass: "alternatives" },
                                            _vm._l(
                                              experiment.design_critique
                                                .alternative_approaches,
                                              function (alt, altIndex) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key:
                                                      "alt-" +
                                                      index +
                                                      "-" +
                                                      altIndex,
                                                    staticClass:
                                                      "alternative-item",
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "alt-type",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(alt.type) + ":"
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(alt.suggestion) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  experiment.design_critique
                                    .strategic_recommendation
                                    ? _c(
                                        "div",
                                        { staticClass: "critique-section" },
                                        [
                                          _c("strong", [
                                            _vm._v("Strategic Recommendation:"),
                                          ]),
                                          _c(
                                            "div",
                                            { staticClass: "strategic-rec" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    experiment.design_critique
                                                      .strategic_recommendation
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]),
                              ])
                            : _vm._e(),
                          experiment.provenance
                            ? _c("div", { staticClass: "experiment-section" }, [
                                _c("h6", { staticClass: "section-title" }, [
                                  _vm._v("Provenance"),
                                ]),
                                _c(
                                  "div",
                                  { staticClass: "provenance-text" },
                                  [
                                    Array.isArray(experiment.provenance)
                                      ? [
                                          _c(
                                            "ul",
                                            { staticClass: "setup-list" },
                                            _vm._l(
                                              experiment.provenance,
                                              function (p, pIdx) {
                                                return _c(
                                                  "li",
                                                  { key: "pv-" + pIdx },
                                                  [
                                                    _vm._v(
                                                      " " + _vm._s(p) + " "
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          ),
                                        ]
                                      : [_vm._v(_vm._s(experiment.provenance))],
                                  ],
                                  2
                                ),
                              ])
                            : _vm._e(),
                        ]
                      )
                    }),
                    _vm.experiments.length > 1
                      ? _c("div", { staticClass: "protocol-footer" }, [
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-sm btn-primary download-btn",
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.$emit("download")
                                },
                              },
                            },
                            [_vm._v(" Download All Experiments ")]
                          ),
                        ])
                      : _vm._e(),
                  ],
                  2
                ),
              ])
            : _vm._e(),
          _vm.showCitationPopup
            ? _c(
                "div",
                {
                  staticClass: "citation-popup-overlay",
                  on: {
                    click: function ($event) {
                      _vm.showCitationPopup = false
                    },
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "citation-popup",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "citation-popup-header" }, [
                        _c("h4", [_vm._v("Citation Information")]),
                        _c(
                          "button",
                          {
                            staticClass: "citation-close-btn",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                _vm.showCitationPopup = false
                              },
                            },
                          },
                          [_vm._v(" × ")]
                        ),
                      ]),
                      _c("div", { staticClass: "citation-popup-content" }, [
                        _vm._m(4),
                        _vm._m(5),
                        _vm._m(6),
                        _vm._m(7),
                        _vm._m(8),
                        _c("p", [
                          _vm._v(
                            " Citation policies for each page or analysis on the Knowledge Center are available here: "
                          ),
                          _c(
                            "a",
                            {
                              attrs: {
                                href: _vm.citationPoliciesUrl,
                                target: "_blank",
                                rel: "noopener",
                              },
                            },
                            [
                              _vm._v(
                                "https://cfdeknowledge.org/r/cfdekc_policies_citation"
                              ),
                            ]
                          ),
                        ]),
                      ]),
                      _c("div", { staticClass: "citation-popup-footer" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-primary",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                _vm.showCitationPopup = false
                              },
                            },
                          },
                          [_vm._v("Close")]
                        ),
                      ]),
                    ]
                  ),
                ]
              )
            : _vm._e(),
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "disclaimer-header" }, [
      _c("h5", [_vm._v("⚠️ Important Disclaimer")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "disclaimer-content" }, [
      _c("p", [
        _c("strong", [
          _vm._v(
            "This tool is designed to help generate testable experiment plans for hypothesis validation, not to provide definitive scientific guidance."
          ),
        ]),
      ]),
      _c("p", [_vm._v("Please note that:")]),
      _c("ul", [
        _c("li", [
          _vm._v(
            " These experiment plans are AI-generated suggestions and should be reviewed by qualified researchers "
          ),
        ]),
        _c("li", [
          _vm._v(
            " Plans may not align with current journal standards, field-specific requirements, or institutional protocols "
          ),
        ]),
        _c("li", [
          _vm._v(
            " Always consult with domain experts and follow established laboratory safety and ethical guidelines "
          ),
        ]),
        _c("li", [
          _vm._v(
            " Verify all technical details, protocols, and safety considerations before implementation "
          ),
        ]),
        _c("li", [
          _vm._v(
            "Consider your specific experimental context, resources, and constraints"
          ),
        ]),
      ]),
      _c("p", [
        _c("em", [
          _vm._v(
            "Use these suggestions as a starting point for discussion and planning, not as final experimental protocols."
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "timeline-disclaimer" }, [
      _c("small", [
        _c("em", [
          _vm._v(
            "Please note these timelines are general estimates, not absolute predictions, and that timelines assume the user already has the animals/cells/experimental reagents in-hand and the appropriate animal and/or institutional protocols in place to conduct these experiments. All researchers should be responsible for conducting their experiments in accordance with ethical guidelines as required by their institution."
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "conditions-disclaimer" }, [
      _c("small", [
        _c("em", [
          _vm._v(
            "Please note: These are general estimates. Researchers should perform a power calculation for each assay to determine the appropriate number of mice required for the experiment based on expected effect size, variability, and desired statistical power."
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("strong", [
        _vm._v(
          "If you use this tool in a scientific publication, presentation, or other output, please cite the CFDE Knowledge Center in the following format:"
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "citation-format" }, [
      _c("p", [
        _vm._v(" The Common Fund Data Ecosystem Knowledge Center ("),
        _c(
          "a",
          {
            attrs: {
              href: "https://www.cfdeknowledge.org",
              target: "_blank",
              rel: "noopener",
            },
          },
          [_vm._v("https://www.cfdeknowledge.org")]
        ),
        _vm._v(
          "), supported by NIH Office of the Director, Fund OT2OD036440. Year Month Date of access; URL of page cited. Specific identifiers/ accession numbers for datasets used. "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("strong", [_vm._v("Additional Citation Requirements:")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ul", [
      _c("li", [
        _vm._v(
          " Users citing data and/or resources collected through other CFDE- or non-CFDE-generated studies should also cite all underlying studies comprising those datasets. "
        ),
      ]),
      _c("li", [
        _vm._v(
          " All published datasets must be cited according to the associated publication, using DOIs and PMIDs when available. "
        ),
      ]),
      _c("li", [
        _vm._v(
          "Data reused from third-party repositories must adhere to their citation policies."
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [_c("strong", [_vm._v("Citation Policies:")])])
  },
]
render._withStripped = true

export { render, staticRenderFns }